var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ClientError } from "graphql-request";
import { __, customPaymentMethods, keysToCamelCase, } from "@jti/fe-common";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { AddBundleProductsToCartDocument, AddConfigurableProductsToCartDocument, AddProductsToCartDocument, AddSimpleProductsToCartDocument, ApplyCampaignToCartDocument, ApplyCouponToCartDocument, CancelOrderDocument, CreateEmptyCartDocument, GetCartIdDocument, GetCartItemsDocument, GetCartPricesDocument, GetCartSelectedPaymentMethodDocument, GetCountriesDocument, GetCouponsDocument, GetCurrencyDocument, GetCustomerAddressesDocument, GetCustomerCartDocument, GetCustomerCartPricesDocument, GetCustomerExportedOrderDetailsDocument, GetCustomerOrderDetailsDocument, GetCustomerOrderDocument, GetCustomerOrdersCountDocument, GetCustomerOrdersDocument, GetCustomerOrdersPaginationDocument, GetCustomerOrdersStatusesDocument, GetOrderAttributesDocument, GetOrderDeliveryLimitsDocument, GetOrderStatusesDocument, GetProductImageDescriptionDocument, GetProductImageDocument, GetProductPriceDocument, GetProductsDocument, GetProductsEssentialsDocument, GetShippingMethodsDocument, GetSticksMatrixDocument, GetStockStatusesDocument, GetStoreConfigDocument, MergeCartsDocument, PlaceOrderDocument, RemoveCampaignFromCartDocument, RemoveCouponFromCartDocument, RemoveItemFromCartDocument, SetAddressesOnCartDocument, SetBillingAddressOnCartByAddressIdDocument, SetBillingAddressOnCartDocument, SetPaymentMethodOnCartDocument, SetShippingAddressesOnCartByAddressIdDocument, SetShippingAddressesOnCartDocument, SetShippingMethodsOnCartDocument, UpdateCartItemQuantityDocument, UpdateCustomerAddressDocument, UpdatePaymentMethodDocument, } from "../types";
import { fromMagentoPickupInformation } from "./utils/fromMagentoPickupInformation";
import { isValidTarget } from "./utils/isValidTarget";
export class MagentoApi {
    constructor(client, getClient) {
        this.client = client;
        this.getClient = getClient;
    }
    fromMagentoProduct({ id, errors, product: { sku, stock_status, name, image: { url: imageUrl }, short_description: { html: description }, flavor, flavor_label, color_label, subtitle, categories, enable_order_quantity_limit, order_quantity_limit, price_range, free_gifts, trade_in, type_id, promotionalOffers, subscription, subscription_format, has_device, }, prices, gift_data, quantity, bundle_options, }, points = 0, rules = []) {
        const decodedCategories = categories.map((category) => ({
            name: category.name,
            uid: Number(atob(category.uid)),
            store_locator_name: category.store_locator_name,
        }));
        return {
            id,
            name,
            sku,
            status: stock_status,
            imageUrl,
            quantity,
            description,
            price: prices.price,
            prices,
            flavor,
            flavor_label,
            color_label,
            subtitle,
            categories: decodedCategories,
            enable_order_quantity_limit,
            order_quantity_limit,
            points: points ? points : 0,
            rules,
            price_range,
            free_gifts,
            tradeIn: trade_in || false,
            type_id,
            isGift: (gift_data === null || gift_data === void 0 ? void 0 : gift_data.is_gift) || false,
            bundle_options,
            promotionalOffers,
            subscription,
            subscription_format,
            errors,
            hasDevice: has_device || false,
        };
    }
    fromMagentoPrices({ shipping_addresses = [], prices: { grand_total, subtotal_excluding_tax, subtotal_including_tax, applied_taxes, discounts }, total_shipping, applied_campaign, subscription_amount, }) {
        let shipping = undefined;
        if (shipping_addresses.length > 0) {
            const { selected_shipping_method } = shipping_addresses[0];
            shipping = selected_shipping_method;
        }
        if (total_shipping) {
            shipping = { amount: total_shipping };
        }
        // get currency from grand_total for subscription_amount, because subscription_amount is Float type
        let subscriptionAmount;
        if (subscription_amount) {
            subscriptionAmount = {
                value: subscription_amount,
                currency: grand_total.currency,
            };
        }
        return Object.assign({ grandTotal: grand_total, subtotal: subtotal_excluding_tax, subtotalIncludingTax: subtotal_including_tax, appliedTaxes: applied_taxes || [], discounts: discounts || [], shipping: shipping === null || shipping === void 0 ? void 0 : shipping.amount, appliedCampaign: applied_campaign }, (subscriptionAmount && { subscriptionAmount }));
    }
    fromMagentoOrderAddress(address) {
        if (address == null) {
            return null;
        }
        const parsedAddress = {
            city: address.city,
            streetName: address.street[0] || "",
            streetNumber: address.street[1] || "",
            streetAdditional: address.street[2] || "",
            countryCode: address.country_code,
            postcode: address.postcode,
            firstname: address.firstname,
            lastname: address.lastname,
            telephone: address.telephone,
            provinceName: address.administrative_area_level_2 || "",
            districtName: address.sublocality_level_2 || "",
            premise: address.premise,
            neighborhood: address.neighborhood,
            landmark: address.landmark,
            buildingNumber: address.building_number,
            district: address.district,
        };
        if ("pickup_information" in address) {
            parsedAddress.pickupInformation = fromMagentoPickupInformation(address.pickup_information);
        }
        return parsedAddress;
    }
    toMagentoAddress(address, saveInAddressBook = false) {
        const { isPickupAddress = false, pickupInformation, city, countryCode: country_code, streetName, streetNumber, streetAdditional, firstname, lastname, telephone, postcode, provinceName, districtName, premise, neighborhood, landmark, buildingNumber, district, } = address;
        return {
            is_pickup_address: isPickupAddress,
            pickup_information: pickupInformation ? JSON.stringify(pickupInformation) : undefined,
            street: [streetName, streetNumber, streetAdditional],
            company: "",
            region: "",
            region_id: 0,
            city,
            country_code,
            firstname,
            lastname,
            telephone,
            postcode,
            save_in_address_book: saveInAddressBook,
            administrative_area_level_2: provinceName,
            sublocality_level_2: districtName,
            premise,
            neighborhood,
            landmark,
            building_number: buildingNumber,
            district,
        };
    }
    getCustomerCart() {
        return __awaiter(this, void 0, void 0, function* () {
            const { customerCart: { id, is_trial_eligible, can_apply_coupons, applied_campaign, available_payment_methods }, } = yield this.client.request(GetCustomerCartDocument);
            return { id, is_trial_eligible, can_apply_coupons, applied_campaign, available_payment_methods };
        });
    }
    checkCartAvailability(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { cart: { id }, } = yield this.client.request(GetCartIdDocument, { cartId }, { Authorization: "" });
                return id !== null;
            }
            catch (error) {
                return false;
            }
        });
    }
    mergeCarts(sourceCartId, destinationCartId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { mergeCarts: { id }, } = yield this.client.request(MergeCartsDocument, {
                sourceCartId,
                destinationCartId,
            });
            return { id };
        });
    }
    createEmptyCart() {
        return __awaiter(this, void 0, void 0, function* () {
            const { createEmptyCart } = yield this.client.request(CreateEmptyCartDocument);
            return { id: createEmptyCart };
        });
    }
    getCartItems(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = [];
            const user = getUser();
            try {
                const { cart: { items }, } = yield this.client.request(GetCartItemsDocument, {
                    cartId,
                });
                const isLoyaltyActive = yield LoyaltyApi.init().getStatus();
                if (!isLoyaltyActive) {
                    return {
                        items: items.map((item) => this.fromMagentoProduct(item)),
                    };
                }
                //@TODO create types for item DESP-41432
                result = yield Promise.all(items.map((item) => {
                    var _a;
                    return LoyaltyApi.init()
                        .getProductPoints((_a = item === null || item === void 0 ? void 0 : item.product) === null || _a === void 0 ? void 0 : _a.sku, item.quantity, user === null || user === void 0 ? void 0 : user.uuid, user === null || user === void 0 ? void 0 : user.ciam_token)
                        .then(({ points, rules }) => (Object.assign(Object.assign({}, item), { points,
                        rules })))
                        .catch(() => {
                        return item;
                    });
                }));
            }
            catch (error) {
                result = error.response.data.cart.items;
            }
            return {
                items: result.filter(Boolean).map((item) => this.fromMagentoProduct(item, item.points, item.rules)),
            };
        });
    }
    getCartPrices(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { cart } = yield this.client.request(GetCartPricesDocument, { cartId });
            return {
                prices: this.fromMagentoPrices(cart),
                available_payment_methods: cart.available_payment_methods,
                minimum_payable_amount: cart.minimum_payable_amount,
            };
        });
    }
    getCustomerCartPrices(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { cart } = yield this.client.request(GetCustomerCartPricesDocument, { cartId });
            return {
                cart: keysToCamelCase(cart),
            };
        });
    }
    removeItemFromCart(cartId, productId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { removeItemFromCart } = yield this.client.request(RemoveItemFromCartDocument, {
                    cartId,
                    itemId: Number(productId),
                });
                return removeItemFromCart;
            }
            catch (error) {
                const { removeItemFromCart } = error.data;
                return removeItemFromCart;
            }
        });
    }
    updateCartItemQuantity(cartId, cartItemId, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { updateCartItems } = yield this.client.request(UpdateCartItemQuantityDocument, {
                    cartId,
                    cartItemId: Number(cartItemId),
                    quantity,
                });
                return updateCartItems;
            }
            catch (error) {
                const { updateCartItems } = error.data;
                return updateCartItems;
            }
        });
    }
    setShippingAddressOnCart(cartId, address) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { setShippingAddressesOnCart: { cart: { id }, }, } = yield this.client.request(SetShippingAddressesOnCartDocument, {
                    cartId,
                    address: this.toMagentoAddress(address), // TODO remove casting once Maybe is fixed (vat_id should be optional)
                });
                return { id };
            }
            catch (error) {
                const { response } = error;
                throw new Error(response.errors[0].message);
            }
        });
    }
    setShippingAddressesOnCartByAddressId(cartId, customerAddressId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { setShippingAddressesOnCart: { cart: { id }, }, } = yield this.client.request(SetShippingAddressesOnCartByAddressIdDocument, {
                    cartId,
                    customer_address_id: customerAddressId,
                });
                return { id };
            }
            catch (error) {
                const { response } = error;
                throw new Error(response.errors[0].message);
            }
        });
    }
    getShippingMethods(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.request(GetShippingMethodsDocument, {
                cartId,
            });
            const { shippingAddresses = [] } = keysToCamelCase(response.cart);
            if (shippingAddresses.length === 0) {
                return {
                    methods: [],
                    methodSelected: null,
                };
            }
            const { availableShippingMethods, selectedShippingMethod } = shippingAddresses[0];
            const availableShippingMethodsSortedAscending = availableShippingMethods.sort((a, b) => a.amount.value - b.amount.value);
            return {
                methods: availableShippingMethodsSortedAscending,
                methodSelected: selectedShippingMethod || null,
            };
        });
    }
    setShippingMethodsOnCart(cartId, carrierCode, methodCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const { setShippingMethodsOnCart: { cart: { id }, }, } = yield this.client.request(SetShippingMethodsOnCartDocument, { cartId, carrierCode, methodCode });
            return { id };
        });
    }
    getCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            const { countries } = yield this.client.request(GetCountriesDocument);
            return {
                countries: countries.map(({ id, two_letter_abbreviation, three_letter_abbreviation, full_name_locale, full_name_english }) => ({
                    id,
                    twoLettersAbbr: two_letter_abbreviation,
                    threeLettersAbbr: three_letter_abbreviation,
                    fullNameLocale: full_name_locale,
                    fullNameEnglish: full_name_english,
                })),
            };
        });
    }
    getCountriesForProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetCountriesDocument);
        });
    }
    getCustomerOrder(orderNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const { customer: { orders: { items: orders }, }, } = yield this.client.request(GetCustomerOrderDocument, {
                orderNumber,
            });
            const order = orders[0];
            if (!order) {
                throw new Error("ORDER_NOT_FOUND");
            }
            const { id, items: orderItems, invoices, billing_address, shipping_address, carrier, number, order_date, shipping_method, shipping_method_code, status, loyalty_info, total: { shipping_handling, discounts, grand_total, subtotal, subtotal_incl_tax, taxes, total_shipping }, total_after_trial, total_including_trial, payment_methods, additional_attributes, } = orders[0];
            const paymentMethod = payment_methods[0].type;
            return {
                orderId: atob(id),
                paymentMethod,
                isZeroValueOrder: paymentMethod === customPaymentMethods.zeroValueOrder,
                isSubscriptionOrder: orderItems.filter((item) => item.product.subscription === 1).length > 0,
                items: orderItems.map((item) => {
                    const { id: item_id, product_name: name, product_sku: sku, quantity_ordered: quantity, product_type, product, gift_data, row_total_incl_tax: price, product_sale_price: productSalePrice, product_sale_price_incl_tax: productSalePriceInclTax, } = item;
                    return {
                        item_id,
                        bundle_options: "bundle_options" in item ? item.bundle_options : undefined,
                        sku,
                        name,
                        price,
                        productSalePrice,
                        productSalePriceInclTax,
                        quantity,
                        isGift: (gift_data === null || gift_data === void 0 ? void 0 : gift_data.is_gift) || false,
                        enable_order_quantity_limit: product.enable_order_quantity_limit,
                        order_quantity_limit: product.order_quantity_limit,
                        imageUrl: product.image.url,
                        categories: product.categories,
                        product_type,
                        description: product.description.html,
                        short_description: product.short_description.html,
                        rules: [],
                        price_range: product.price_range,
                        subscription: product.subscription,
                        subscription_format: product.subscription_format,
                    };
                }),
                invoiceUrl: invoices.length > 0 ? invoices[0].url : undefined,
                shippingAddress: this.fromMagentoOrderAddress(shipping_address),
                billingAddress: this.fromMagentoOrderAddress(Object.assign(Object.assign({}, billing_address), { pickup_information: "" })),
                number,
                orderDate: order_date,
                shippingMethod: {
                    methodCode: shipping_method,
                    carrierCode: carrier,
                },
                status,
                prices: this.fromMagentoPrices({
                    prices: {
                        discounts,
                        grand_total,
                        subtotal_excluding_tax: subtotal,
                        subtotal_including_tax: subtotal_incl_tax,
                        applied_taxes: taxes.map((_a) => {
                            var { title } = _a, tax = __rest(_a, ["title"]);
                            return (Object.assign(Object.assign({}, tax), { label: title }));
                        }),
                    },
                    total_shipping,
                    applied_campaign: loyalty_info,
                    total_after_trial,
                    available_payment_methods: [],
                }),
                total_including_trial,
                total_after_trial,
                shipping_handling,
                methodAndCarrierCode: shipping_method_code,
                additional_attributes,
            };
        });
    }
    cancelCustomerOrder(orderNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const { cancelorder: result } = yield this.client.request(CancelOrderDocument, { orderNumber });
            return {
                success: result === true,
            };
        });
    }
    getCustomerAddresses() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetCustomerAddressesDocument);
        });
    }
    getCustomerOrdersCount(scope) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetCustomerOrdersCountDocument, { scope });
        });
    }
    getCustomerOrders(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetCustomerOrdersDocument, filter ? { filter } : undefined);
        });
    }
    getCustomerOrdersStatuses(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetCustomerOrdersStatusesDocument, filter ? { filter } : undefined);
        });
    }
    getCustomerOrdersPagination(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetCustomerOrdersPaginationDocument, Object.assign({}, opts));
        });
    }
    getOrderAttributes() {
        return __awaiter(this, void 0, void 0, function* () {
            const { getOrderAttributes: orderAttributes } = yield this.client.request(GetOrderAttributesDocument);
            const formattedOrderAttributes = orderAttributes
                .filter((attribute) => isValidTarget(attribute.placement))
                .map((attribute) => (Object.assign(Object.assign({}, attribute), { placement: attribute.placement })));
            return formattedOrderAttributes;
        });
    }
    getCustomerOrderDetails(orderNumber, scope) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetCustomerOrderDetailsDocument, { number: orderNumber, scope });
        });
    }
    getCustomerExportOrderDetails(orderNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetCustomerExportedOrderDetailsDocument, { number: orderNumber });
        });
    }
    getOrderStatuses() {
        return __awaiter(this, void 0, void 0, function* () {
            const { getorderstatus: getOrderStatus } = yield this.client.request(GetOrderStatusesDocument);
            const translatedStatuses = getOrderStatus.map((_a) => {
                var { status_label, status_value } = _a, status = __rest(_a, ["status_label", "status_value"]);
                return Object.assign(Object.assign({}, status), { status_label: __(`com.order.status_code.${status_value}.text`, undefined, status_label) || status_label, status_value });
            });
            return { getorderstatus: translatedStatuses };
        });
    }
    updateCustomerAddress(id, address) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(UpdateCustomerAddressDocument, { addressId: id, address });
        });
    }
    getProductImage(sku) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getClient.request(GetProductImageDocument, {
                sku,
            });
        });
    }
    getProductImageDescription(skuArr) {
        return __awaiter(this, void 0, void 0, function* () {
            const { products: { items }, } = yield this.client.request(GetProductImageDescriptionDocument, { sku: skuArr });
            return {
                products: items.map(({ sku, description: { html: description }, image: { url: imageUrl } }) => ({
                    sku,
                    description,
                    imageUrl,
                })),
            };
        });
    }
    getDefaultShippingMethods(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getShippingMethods(cartId);
        });
    }
    setBillingAddressOnCartByAddressId(cartId, customerAddressId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { setBillingAddressOnCart: { cart: { id }, }, } = yield this.client.request(SetBillingAddressOnCartByAddressIdDocument, {
                    cartId,
                    customer_address_id: customerAddressId,
                });
                return { id };
            }
            catch (error) {
                const { response } = error;
                throw new Error(response.errors[0].message);
            }
        });
    }
    setBillingAddressOnCart(cartId, address) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { setBillingAddressOnCart: { cart: { id }, }, } = yield this.client.request(SetBillingAddressOnCartDocument, {
                    cartId,
                    address: this.toMagentoAddress(address), // TODO remove casting once Maybe is fixed (vat_id should be optional)
                });
                return { id };
            }
            catch (error) {
                const { response } = error;
                throw new Error(response.errors[0].message);
            }
        });
    }
    setAddressesOnCart(cartId, shipping_address_input, billing_address_input) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { setBillingAddressOnCart: { cart: { id }, }, } = yield this.client.request(SetAddressesOnCartDocument, {
                    cartId,
                    shipping_addresses: this.toMagentoAddress(shipping_address_input),
                    billing_address: this.toMagentoAddress(billing_address_input),
                });
                return { id };
            }
            catch (error) {
                throw new ClientError(error.response, error.request);
            }
        });
    }
    setPaymentMethodOnCart(cartId, code) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(SetPaymentMethodOnCartDocument, {
                cartId,
                code,
            });
        });
    }
    getSelectedPaymentMethod(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetCartSelectedPaymentMethodDocument, {
                cartId,
            });
        });
    }
    placeOrder(cartId, additionalAttributes, paymentMethod = "jtipayment") {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setPaymentMethodOnCart(cartId, paymentMethod);
            const { placeOrder: { order: { entity_id, order_number }, }, } = yield this.client.request(PlaceOrderDocument, {
                cartId,
                additionalAttributes,
            });
            return {
                orderNumber: order_number,
                entityId: entity_id,
            };
        });
    }
    getCoupons(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { cart: { applied_coupons: coupons }, } = yield this.client.request(GetCouponsDocument, { cartId });
            return { coupons };
        });
    }
    applyCouponToCart(cartId, couponCodes) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { applyCouponToCart: { cart: { applied_coupons, can_apply_coupons, messages }, }, } = yield this.client.request(ApplyCouponToCartDocument, {
                    cartId,
                    couponCode: couponCodes.join(","),
                });
                return {
                    appliedCoupons: applied_coupons,
                    can_apply_coupons,
                    messages,
                };
            }
            catch (error) {
                const { errors, data } = (_a = error === null || error === void 0 ? void 0 : error.response) !== null && _a !== void 0 ? _a : {};
                const { applyCouponToCart, cartCanApplyCoupons } = data !== null && data !== void 0 ? data : {};
                const messages = [(_c = (_b = errors === null || errors === void 0 ? void 0 : errors[0]) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : __("cart.checkout.error.promo_code")];
                if (applyCouponToCart) {
                    const { cart: { applied_coupons }, } = applyCouponToCart;
                    return {
                        appliedCoupons: applied_coupons,
                        can_apply_coupons: !!cartCanApplyCoupons,
                        messages,
                    };
                }
                return {
                    appliedCoupons: [],
                    can_apply_coupons: !!cartCanApplyCoupons,
                    messages,
                };
            }
        });
    }
    removeCouponFromCart(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(RemoveCouponFromCartDocument, {
                cartId,
            });
        });
    }
    applyCampaignToCart(cartId, campaign_uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(ApplyCampaignToCartDocument, {
                cartId,
                campaign_uuid,
            });
        });
    }
    removeCampaignFromCart(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(RemoveCampaignFromCartDocument, {
                cartId,
            });
        });
    }
    addProductsToCart(cartId, items) {
        return __awaiter(this, void 0, void 0, function* () {
            const nonEmptyItems = items.filter(({ quantity }) => quantity > 0);
            const cartItems = nonEmptyItems.map(({ quantity, productSku, giftSku }) => ({
                quantity,
                sku: giftSku,
                entered_options: [
                    {
                        uid: btoa("custom-option/is_gift"),
                        value: "true",
                    },
                    {
                        uid: btoa("custom-option/parent_gift_sku"),
                        value: productSku,
                    },
                ],
            })); // TODO remove casting once codegen is configured with Maybe as optional
            if (cartItems.length === 0) {
                return Promise.resolve(null);
            }
            return this.client.request(AddProductsToCartDocument, {
                cartId,
                cartItems,
            });
        });
    }
    addSimpleProductsToCart(cartId, sku, quantity = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(AddSimpleProductsToCartDocument, {
                cartId,
                sku,
                quantity,
            });
        });
    }
    addConfigurableProductToCart(cartId, sku, parentSku, quantity = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(AddConfigurableProductsToCartDocument, {
                cartId,
                sku,
                parentSku,
                quantity,
            });
        });
    }
    addBundleProductsToCart(cartId, sku, bundleOptions, quantity = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(AddBundleProductsToCartDocument, {
                cartId,
                sku,
                bundleOptions,
                quantity,
            });
        });
    }
    removeItemsFromCart(cartId, productIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.all(productIds.map((productId) => this.removeItemFromCart(cartId, productId)));
        });
    }
    getCurrency() {
        return __awaiter(this, void 0, void 0, function* () {
            const { currency } = yield this.getClient.request(GetCurrencyDocument);
            return keysToCamelCase(currency);
        });
    }
    getStoreConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            const { storeConfig: { store_code, store_group_code, website_code, is_order_limit_enabled, is_age_verification_enabled, is_free_gifts_enabled, gift_basket_quantity_limitation, order_limit_value, base_currency_code, postcode_is_required, postcode_max_length, postcode_min_length, postcode_validate_regex, postcode_validation_enabled, allow_empty_firstname, cartons_limit_value, }, } = yield this.getClient.request(GetStoreConfigDocument);
            return {
                store_code,
                store_group_code,
                website_code,
                is_order_limit_enabled,
                is_age_verification_enabled,
                is_free_gifts_enabled,
                gift_basket_quantity_limitation,
                order_limit_value,
                base_currency_code,
                postcode_is_required,
                postcode_max_length,
                postcode_min_length,
                postcode_validate_regex,
                postcode_validation_enabled,
                allow_empty_firstname,
                cartons_limit_value,
            };
        });
    }
    getOrderDeliveryLimits() {
        return __awaiter(this, void 0, void 0, function* () {
            const { getOrderDeliveryLimits: { limits, mode }, } = yield this.client.request(GetOrderDeliveryLimitsDocument);
            return {
                limits,
                mode,
            };
        });
    }
    updatePaymentMethod(orderId, methodCode) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { updatePaymentMethod } = yield this.client.request(UpdatePaymentMethodDocument, {
                    orderId,
                    methodCode,
                });
                return updatePaymentMethod;
            }
            catch (error) {
                const { updatePaymentMethod } = error.data;
                return updatePaymentMethod;
            }
        });
    }
    getProductsDetailsBySku(sku, pageSize) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetProductsDocument, {
                sku,
                pageSize,
            });
        });
    }
    getProductsEssentialsBySku(sku, pageSize) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetProductsEssentialsDocument, {
                sku,
                pageSize,
            });
        });
    }
    CUSTOM_TYPES_BETA__getProductsDetailsBySku(skus, pageSize) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.request(GetProductsDocument, {
                sku: skus,
                pageSize,
            });
            return keysToCamelCase(response);
        });
    }
    getStockStatuses(sku, pageSize) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.request(GetStockStatusesDocument, {
                sku,
                pageSize,
            });
        });
    }
    getProductPrice(sku, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.request(GetProductPriceDocument, {
                sku,
                quantity,
            });
            return keysToCamelCase(response.getProductPrice);
        });
    }
    getSticksMatrix() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.request(GetSticksMatrixDocument);
            return keysToCamelCase(response.getSticksMatrix);
        });
    }
}
//# sourceMappingURL=MagentoApi.js.map